import {
  ColDef,
  ICellRendererParams,
  ISetFilterParams,
} from '@ag-grid-community/core'
import { generateMdiIcon } from '../utils/icon-utils'
import { heliosDefaultColWidth } from './default'

/** Ag-grid cell renderer that displays a tri-state checkbox icon. */
export const checkboxCellRenderer = (params: ICellRendererParams) => {
  const checked: boolean | undefined = params.value
  const icon =
    checked === true
      ? 'mdi-checkbox-marked'
      : checked === false
      ? 'mdi-checkbox-blank-outline'
      : 'mdi-minus-box-outline'

  return generateMdiIcon(icon)
}

export const HsBooleanColDef: ColDef = {
  cellRenderer: checkboxCellRenderer,
  filter: 'agSetColumnFilter',
  filterParams: {
    values: [true, false],
    buttons: ['apply', 'reset'],
    suppressSelectAll: true,
    suppressMiniFilter: true,
    suppressSorting: true,
    defaultToNothingSelected: true,
    closeOnApply: true,
    valueFormatter: params => {
      const checked: 'true' | 'false' | undefined = params.value
      return checked === 'true' ? 'Yes' : checked === 'false' ? 'No' : 'N/A'
    },
  } as ISetFilterParams,
  sortable: false,
  width: heliosDefaultColWidth.SmallIcon,
  filterValueGetter: params => {
    const value = params.getValue(params.colDef.field ?? '')
    const checked: boolean | undefined = value
    return checked === true ? 'true' : checked === false ? 'false' : undefined
  },
}
